(function () {
  'use strict';

  function setMobileNavOpen(isOpen) {
    var nav = document.querySelector('[data-bac-mobile-nav]');
    var btn = document.querySelector('[data-bac-menu-toggle]');
    if (!nav) return;

    nav.classList.toggle('is-open', isOpen);
    document.body.classList.toggle('bac-menu-open', isOpen);

    if (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      btn.setAttribute('aria-label', isOpen ? 'Închide meniul' : 'Deschide meniul');
    }
  }

  /* Mobile menu toggle */
  document.querySelectorAll('[data-bac-menu-toggle]').forEach(function (btn) {
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-bac-mobile-nav]');
      setMobileNavOpen(!nav || !nav.classList.contains('is-open'));
    });
  });

  /* Close menu on resize to desktop */
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 768) setMobileNavOpen(false);
  });

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#bac-"], a[href^="#cookies-"], a[href*="#bac-"], a[href*="#cookies-"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      var hash = href.slice(hashIndex);
      var target = document.querySelector(hash);
      if (!target) return;

      var isBacHash = hash.indexOf('bac-') !== -1;
      var isCookiesHash = hash.indexOf('cookies-') !== -1;
      if (!isBacHash && !isCookiesHash) return;

      var onHome = window.location.pathname === '/' || window.location.pathname === '';
      if (isBacHash && !onHome) return;

      e.preventDefault();
      setMobileNavOpen(false);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Table of contents accordion */
  document.querySelectorAll('[data-bac-toc-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = this.closest('[data-bac-toc-item]');
      var wasOpen = item.classList.contains('is-open');

      document.querySelectorAll('[data-bac-toc-item]').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('[data-bac-toc-trigger]')?.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    trigger.setAttribute('aria-expanded', trigger.closest('[data-bac-toc-item]')?.classList.contains('is-open') ? 'true' : 'false');
  });

  /* Book preview carousel — drag to flip pages */
  document.querySelectorAll('[data-bac-slider]').forEach(function (slider) {
    var slidesWrap = slider.querySelector('.bac-preview__slides');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-bac-slide]'));
    var dots = slider.querySelectorAll('[data-bac-dot]');
    var prev = slider.querySelector('[data-bac-prev]');
    var next = slider.querySelector('[data-bac-next]');
    var current = 0;
    var track = null;
    var drag = {
      active: false,
      startX: 0,
      deltaX: 0,
      width: 0,
      pointerId: null
    };

    if (!slidesWrap || slides.length <= 1) return;

    track = document.createElement('div');
    track.className = 'bac-preview__track';
    slides.forEach(function (slide) {
      track.appendChild(slide);
    });
    slidesWrap.appendChild(track);

    function clampIndex(index) {
      return Math.max(0, Math.min(slides.length - 1, index));
    }

    function setTrack(offsetPx, withTransition) {
      if (!withTransition) slider.classList.add('is-dragging');
      else slider.classList.remove('is-dragging');
      track.style.transform = 'translate3d(' + offsetPx + 'px, 0, 0)';
    }

    function syncActive() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    }

    function goTo(index) {
      current = clampIndex(index);
      var width = slidesWrap.getBoundingClientRect().width;
      setTrack(-current * width, true);
      syncActive();
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag.active = true;
      drag.startX = e.clientX;
      drag.deltaX = 0;
      drag.width = slidesWrap.getBoundingClientRect().width;
      drag.pointerId = e.pointerId;
      slidesWrap.setPointerCapture(e.pointerId);
      setTrack(-current * drag.width + drag.deltaX, false);
    }

    function onPointerMove(e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      drag.deltaX = e.clientX - drag.startX;
      var resistance = 0.35;
      var atStart = current === 0 && drag.deltaX > 0;
      var atEnd = current === slides.length - 1 && drag.deltaX < 0;
      var offset = drag.deltaX;
      if (atStart || atEnd) offset *= resistance;
      setTrack(-current * drag.width + offset, false);

      var activeImg = slides[current] && slides[current].querySelector('img');
      if (activeImg && drag.deltaX < 0) {
        var progress = Math.min(1, Math.abs(drag.deltaX) / drag.width);
        activeImg.style.transform = 'perspective(900px) rotateY(' + (-8 * progress) + 'deg) scale(' + (1 - progress * 0.03) + ')';
      } else if (activeImg) {
        activeImg.style.transform = '';
      }
    }

    function onPointerUp(e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      drag.active = false;
      slidesWrap.releasePointerCapture(e.pointerId);

      var activeImg = slides[current] && slides[current].querySelector('img');
      if (activeImg) activeImg.style.transform = '';

      var threshold = Math.max(48, drag.width * 0.18);
      if (drag.deltaX <= -threshold) goTo(current + 1);
      else if (drag.deltaX >= threshold) goTo(current - 1);
      else goTo(current);
    }

    slidesWrap.addEventListener('pointerdown', onPointerDown);
    slidesWrap.addEventListener('pointermove', onPointerMove);
    slidesWrap.addEventListener('pointerup', onPointerUp);
    slidesWrap.addEventListener('pointercancel', onPointerUp);

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    window.addEventListener('resize', function () {
      goTo(current);
    });

    goTo(0);
  });

  /* Open cart drawer from BAC header cart button */
  document.querySelectorAll('[data-bac-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    });
  });

  function getBacDefaultVariantId() {
    var defaultVariant = document.querySelector('[data-bac-default-variant-id]');
    return defaultVariant ? defaultVariant.dataset.bacDefaultVariantId : '';
  }

  function setBuyNowLoadingState(trigger, isLoading) {
    if (!trigger) return;
    if (trigger.tagName === 'BUTTON') {
      trigger.disabled = isLoading;
      return;
    }

    if (isLoading) {
      trigger.setAttribute('aria-disabled', 'true');
      trigger.classList.add('is-disabled');
    } else {
      trigger.removeAttribute('aria-disabled');
      trigger.classList.remove('is-disabled');
    }
  }

  function addToCartAndGoToCheckout(variantId, trigger) {
    if (!variantId) return;

    var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
    setBuyNowLoadingState(trigger, true);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        setBuyNowLoadingState(trigger, false);
      });
  }

  /* BAC CTA buy now: add to cart then go to checkout */
  document.querySelectorAll('[data-bac-buy-now], [data-bac-add-to-cart]').forEach(function (cta) {
    cta.addEventListener('click', function (event) {
      if (cta.tagName === 'BUTTON' && cta.disabled) return;
      if (cta.getAttribute('aria-disabled') === 'true') return;

      var variantId = cta.dataset.variantId || getBacDefaultVariantId();
      if (!variantId) return;

      event.preventDefault();
      addToCartAndGoToCheckout(variantId, cta);
    });
  });

  /* Fallback add to cart — works even if product-form-component fails to bind */
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function openBacCartDrawer(cart) {
    if (cart && cart.item_count !== undefined) {
      updateBacCartBadge(cart.item_count);
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'bac-product-form',
          data: {
            itemCount: 1,
            source: 'product-form-component',
          },
        },
      })
    );

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.showDialog === 'function') drawer.showDialog();
    }
  }

  document.querySelectorAll('[data-bac-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var productForm = form.closest('product-form-component');
      var ProductFormComponent = customElements.get('product-form-component');
      if (productForm && ProductFormComponent && productForm instanceof ProductFormComponent) {
        return;
      }

      event.preventDefault();

      var submitBtn = form.querySelector('[type="submit"][name="add"]');
      if (submitBtn && submitBtn.disabled) return;

      var variantId = form.querySelector('[name="id"]')?.value;
      var quantity = form.querySelector('[name="quantity"]')?.value || '1';
      if (!variantId) return;

      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      var sectionIds = getCartSectionIds();
      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
      }

      var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) throw new Error(data.message || 'cart add failed');
          openBacCartDrawer(data);
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });

  /* Keep BAC header cart badge in sync with AJAX cart updates */
  function updateBacCartBadge(count) {
    var cartBtn = document.querySelector('.bac-header__cart');
    if (!cartBtn) return;

    var badge = cartBtn.querySelector('.bac-header__cart-badge');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bac-header__cart-badge';
        cartBtn.appendChild(badge);
      }
      badge.textContent = String(count);
    } else if (badge) {
      badge.remove();
    }
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.didError) return;

    var totalCount = detail.resource && detail.resource.item_count;
    if (totalCount !== undefined) {
      updateBacCartBadge(totalCount);
    }
  });
})();
